import React from 'react';

const SponsorBanner = ({ className = '', size = 'md' }) => {
  const logoH = size === 'sm' ? 'h-8' : size === 'lg' ? 'h-14' : 'h-11';
  return (
    <div
      className={`flex items-center justify-center gap-3 bg-white dark:bg-gray-100 border-2 border-gray-200 dark:border-gray-300 rounded-2xl py-3 px-6 shadow-md ${className}`}
      data-testid="sponsor-banner"
    >
      <span className="text-base font-bold text-gray-600">הפרסים לתחרות בחסות</span>
      <img
        src={`${process.env.PUBLIC_URL || ''}/wilson-logo.png`}
        alt="Wilson"
        crossOrigin="anonymous"
        className={`${logoH} w-auto object-contain`}
      />
    </div>
  );
};

export default SponsorBanner;
